import React, { useEffect, useRef } from "react";

/**
 * ContextMenu — a small reusable right-click menu positioned at the cursor.
 * Closes on outside click, Escape, scroll, or after an item is chosen.
 *
 * props:
 *  - x, y: viewport coordinates
 *  - items: [{ label, onClick, danger?, separator? }]
 *  - onClose: () => void
 */
const ContextMenu = ({ x, y, items, onClose }) => {
  const ref = useRef(null);

  useEffect(() => {
    const onDown = (e) => {
      if (ref.current && !ref.current.contains(e.target)) onClose();
    };
    const onKey = (e) => e.key === "Escape" && onClose();
    document.addEventListener("mousedown", onDown);
    document.addEventListener("keydown", onKey);
    window.addEventListener("blur", onClose);
    return () => {
      document.removeEventListener("mousedown", onDown);
      document.removeEventListener("keydown", onKey);
      window.removeEventListener("blur", onClose);
    };
  }, [onClose]);

  // Keep the menu on-screen.
  const style = {
    left: Math.min(x, (typeof window !== "undefined" ? window.innerWidth : 9999) - 220),
    top: Math.min(y, (typeof window !== "undefined" ? window.innerHeight : 9999) - 8 - items.length * 34),
  };

  return (
    <div className="webtop-ctxmenu" style={style} ref={ref} role="menu">
      {items.map((item, i) =>
        item.separator ? (
          <div key={`sep-${i}`} className="webtop-ctxmenu__sep" />
        ) : (
          <button
            key={item.label}
            type="button"
            role="menuitem"
            className={`webtop-ctxmenu__item${item.danger ? " webtop-ctxmenu__item--danger" : ""}`}
            disabled={item.disabled}
            onClick={() => {
              onClose();
              item.onClick && item.onClick();
            }}
          >
            {item.label}
          </button>
        )
      )}
    </div>
  );
};

export default ContextMenu;
